module.exports = __webpack_public_path__ + "img/overview-icon.f1b7ec7a.svg";